import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { connect } from "react-redux";
import {
  login,
  forgotPasswordOTP,
} from "../../../Store/Actions/userActionCreator";
import { CustomTextField, Button, CountryCodeSelect } from "../../UI";
import Modal from "../Modal";
import { useFormik } from "formik";
import * as yup from "yup";
import { DEFAULT_COUNTRY_CODE, getMobileError } from "../../../Utils/mobile";
import { withRouter } from "react-router-dom";
import { ForgetPasswordImage } from "../../../Assets/svg";
import ResetPasswordModal from "./ResetPasswordModal";
import "./style.scss";
import { showMessage } from "../../../Utils/helper";

// const validationSchema = yup.object({
//   userId: yup
//     .string("Please enter valid email")
//     .when("userId", {
//       is: (userId) => !!Number(userId),
//       then: yup
//         .string("Please enter valid email")
//         .email("Please enter valid email"),
//       otherwise: yup.number("Please enter valid email"),
//     })
//     .trim()
//     .required("Email/Mobile Number cannot be empty"),
// });

const validationSchema = yup.lazy((values) => {
  return yup.object({
    userId: yup.string().when("isEmail", {
      is: "1",
      then: yup
        .string()
        .email("Please enter valid email")
        .required("Email / Phone Number cannot be empty"),
      otherwise: yup
        .string()
        .required("Email / Phone Number cannot be empty")
        .test("mobile", function (value) {
        const error = getMobileError(this.parent.countryCode, value);
        return error ? this.createError({ message: error }) : true;
      }),
    }),
  });
});

function ForgetPasswordModal({
  open,
  onClose,
  dispatchForgotPasswordOTP,
  ...props
}) {
  const [isOpen, toggleModal] = useState(open);
  const [loading, toggleLoading] = useState(false);
  const [openEmailOtpModal, setOpenEmailOtpModal] = useState(false);
  const handleClose = () => {
    // Setting form data to null before closing

    toggleModal(!isOpen);
    onClose && onClose();
  };

  const formik = useFormik({
    initialValues: {
      userId: "",
      countryCode: DEFAULT_COUNTRY_CODE,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, err) => {
      toggleLoading(true);
      dispatchForgotPasswordOTP(
        { userId: values.userId },
        (resp) => {
          if (!!resp?.status) {
            toggleLoading(false);
            setOpenEmailOtpModal(true);
            toggleModal(!isOpen);
          } else {
            showMessage(resp?.result, "error");
            toggleLoading(false);
          }
        },
        (err) => {
          toggleLoading(false);
          handleClose();
          // showMessage(err, "error");
        }
      );
    },
  });

  const actions = [];
  return (
    <>
      <Modal
        onClose={handleClose}
        open={isOpen}
        title={""}
        actions={actions}
        loading={loading}
        isForm={true}
        onSubmit={formik.handleSubmit}
        maxWidth="md"
        className="forgotmodelcss"
      >
        <Box className="mainbox">
          <ForgetPasswordImage className="forgetimg" />
          <Box className="modelforum">
            <Typography
              variant="h4"
              style={{
                textAlign: "center",
                marginTop: "8px",
                marginBottom: "24px",
                // fontFamily: "Montserrat",
                fontWeight: "bold",
              }}
            >
              Forgot Password?
            </Typography>
            <Typography
              //   variant="h6"
              style={{
                marginTop: "8px",
                marginBottom: "24px",
                // fontFamily: "Montserrat",
                color: "#000000",
              }}
            >
              Please enter the Email address/Mobile Number associated with the
              account
            </Typography>
            <Typography fontSize={"0.8em"} color={"red"} marginBottom={"10px"}>
              For Email OTP, Please check the Spam/Promotions folder.
            </Typography>
            <Typography fontSize={"0.8em"} color={"#000000"} marginBottom={"10px"}>
              OTP for non-India mobile numbers is sent on WhatsApp.
            </Typography>
            <Box style={{ display: "flex", gap: "8px", marginBottom: "16px", width: "100%" }}>
            {!!formik.values.userId && formik.values.isEmail !== "1" && (
              <CountryCodeSelect
                value={formik.values.countryCode}
                onChange={formik.handleChange}
                style={{ width: "40%", minWidth: 110 }}
              />
            )}
            <CustomTextField
              fullWidth={true}
              label="Enter E-Mail/Mobile Number"
              id="userId"
              name="userId"
              value={formik.values.userId}
              // onChange={formik.handleChange}
              onChange={(event) => {
                const userId = event.target.value;
                formik.setValues({
                  ...formik.values,
                  userId,
                  isEmail: /^\d+$/.test(userId) ? "0" : "1",
                });
              }}
              error={
                formik.touched.userId ? Boolean(formik.errors.userId) : false
              }
              helperText={formik.touched.userId && formik.errors.userId}
              style={{ flex: 1 }}
            />
          </Box>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              style={{
                fontWeight: "bold",
              }}
              type="submit"
            >
              SEND OTP
            </Button>
          </Box>
        </Box>
      </Modal>
      {!!openEmailOtpModal && (
        <ResetPasswordModal
          open={openEmailOtpModal}
          data={{ emailId: formik?.values?.userId, validateViaOTP: true }}
          onClose={() => {
            setOpenEmailOtpModal(false);
          }}
          next={() => {
            setOpenEmailOtpModal(false);
            handleClose();
          }}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchLogin: (payload, onSuccess, onError) =>
    dispatch(login(payload, onSuccess, onError)),
  dispatchForgotPasswordOTP: (payload, onSuccess, onError) =>
    dispatch(forgotPasswordOTP(payload, onSuccess, onError)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ForgetPasswordModal));
